// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"7104adcb","917":"7fcc4a0b"}[chunkId] + ".chunk.js";
};